import { NavLink } from 'react-router-dom';

import CartLink from '@/ui/CartLink';
import LangSwitcher from '@/ui/LangSwitcher';

import styles from './MenuOverlay.module.css';

interface LinkDef {
  to: string;
  label: string;
}

interface MenuOverlayProps {
  open: boolean;
  onClose: () => void;
  links: LinkDef[];
  countdownLabel: string;
}

export default function MenuOverlay({
  open,
  onClose,
  links,
  countdownLabel,
}: MenuOverlayProps) {
  if (!open) return null;

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <button type="button" className={styles.close} onClick={onClose} aria-label="Close menu">
        ×
      </button>

      <div className={styles.meta}>
        <span>MOCT / TRANSMISSION / 2026</span>
        <span>{countdownLabel}</span>
      </div>

      <div className={styles.links}>
        {links.map((l, i) => (
          <NavLink
            key={l.to}
            to={l.to}
            onClick={onClose}
            className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
          >
            <span className={styles.num}>/{String(i + 1).padStart(2, '0')}</span>
            <span className={styles.label}>{l.label}</span>
          </NavLink>
        ))}
      </div>

      <div className={styles.foot}>
        <LangSwitcher />
        <CartLink onClick={onClose} />
      </div>
    </div>
  );
}
